import type { ISelectOptionItemType } from '@home/components/SingleSelect/type';
import defaultGameIcon from '@/pages/dashboard/assets/svg/console-game-default.svg';

/** 从经分路由 pathname 提取 gameCode，例: /dashboard/game/pc_demo/overview/monthly -> pc_demo */
export const extractDashboardGameCodeFromPath = (pathname: string): string => {
  const segments = pathname.split('/').filter(Boolean);
  const gameIndex = segments.findIndex((seg) => seg === 'game');
  if (gameIndex >= 0 && segments[gameIndex + 1]) {
    return segments[gameIndex + 1];
  }
  return '';
};

/** 主版本 + 子版本递归查找 game */
export const findGame = (gameCode: string, mainGames: any[]) => {
  const mainGame = mainGames.find((g: any) =>
    g.game_code === gameCode || g.game_List?.some((sub: any) => sub.game_code === gameCode),
  );
  return mainGame?.game_code === gameCode
    ? mainGame
    : mainGame?.game_List?.find((sub: any) => sub.game_code === gameCode);
};

/** 将游戏数据转为下拉/触发器展示项 */
export const toGameSelectOption = (
  game: any,
  locale: string,
): ISelectOptionItemType | null => {
  if (!game) return null;
  const isZh = locale === 'zh-CN';
  return {
    value: game.game_code,
    text: isZh
      ? (game.game_cn_name || game.game_name || game.game_code)
      : (game.game_name || game.game_cn_name || game.game_code),
    icon: game.cover || defaultGameIcon,
  };
};

/** 按 game_code 从主版本树解析展示项（触发器回显、标签构建共用） */
export const resolveGameSelectOption = (
  gameCode: string,
  mainGames: any[],
  locale: string,
): ISelectOptionItemType | null => {
  if (!gameCode) return null;
  return toGameSelectOption(findGame(gameCode, mainGames), locale);
};
